import React from 'react';

interface SkeletonLoaderProps {
    rows?: number;
    className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ rows = 3, className = 'h-[72px] rounded-2xl' }) => (
    <>
        {Array.from({ length: rows }).map((_, i) => (
            <div
                key={i}
                className={`bg-[var(--neutral-color)] animate-pulse ${className}`}
            />
        ))}
    </>
);

export default SkeletonLoader;
